import angular from 'angular';

import editTrainingPresentationDirective from './edit-presentation.directive';
import EditTrainingPresentationDirectiveController from './edit-presentation.directive.controller';

import thumbnailMessage from './presentation-thumbnail.messages.html';
import message from './presentation.messages.html';

export default angular.module('app.components.admin.trainingAdministration.media.editMedia.editPresentationDialog', [])
  .directive('editTrainingPresentation', editTrainingPresentationDirective)
  .controller('EditTrainingPresentationDirectiveController', EditTrainingPresentationDirectiveController)
  .run(($templateCache) => {
    $templateCache.put('presentation-thumbnail.messages.html', thumbnailMessage);
    $templateCache.put('presentation.messages.html', message);
  })
  .name;

console.log('app.components.admin.trainingAdministration.media.editMedia.editPresentationDialog created');
